// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2kT0x","form":"styles_form__w-obl"};